export interface LocationStockBatchRef {
  batch_id?: number | null;
  product_id?: number;
  quantity?: number;
  batch?: {
    id?: number;
    batch_number?: string | null;
    expiry_date?: string | null;
  } | null;
}

/** Lotes con stock en la ubicación para un producto concreto. */
export function getLocationBatchIdsForProduct(
  stockBatches: LocationStockBatchRef[] | undefined,
  productId: number,
): number[] {
  if (!stockBatches?.length || !productId) return [];

  return stockBatches
    .filter((entry) => entry.product_id === productId && (entry.quantity ?? 0) > 0 && entry.batch_id != null)
    .map((entry) => Number(entry.batch_id));
}

export function getLocationBatchLabel(
  stockBatches: LocationStockBatchRef[] | undefined,
  productId: number,
): string | null {
  const entry = stockBatches?.find(
    (batch) => batch.product_id === productId && (batch.quantity ?? 0) > 0 && batch.batch_id != null,
  );
  if (!entry) return null;

  const batchNumber = entry.batch?.batch_number?.trim();
  if (batchNumber) return batchNumber;

  return entry.batch_id != null ? `#${entry.batch_id}` : null;
}

/** Si la ubicación ya tiene stock con lote, solo ese lote es válido para el mismo producto. */
export function isBatchCompatibleWithLocation(
  lineBatchId: number | null | undefined,
  productId: number,
  stockBatches: LocationStockBatchRef[] | undefined,
): boolean {
  const locationBatchIds = getLocationBatchIdsForProduct(stockBatches, productId);
  if (locationBatchIds.length === 0) return true;
  if (lineBatchId == null) return false;
  return locationBatchIds.includes(Number(lineBatchId));
}

export function filterLinesCompatibleWithLocation<T extends { product_id?: number; batch_id?: number | null }>(
  lines: T[],
  stockBatches: LocationStockBatchRef[] | undefined,
): T[] {
  return lines.filter((line) => isBatchCompatibleWithLocation(line.batch_id, line.product_id ?? 0, stockBatches));
}
